<kendo-expansionpanel [title]="title"
                      [subtitle]="'Total: ' + opportunityList.length"
                      [expanded]="expanded">
    <div class="row">
        <div class="col-sm-12" *ngIf="!isEditOpportunity && !isAddOpportunity">
            <!--<span class="float-right" style="margin-right:-25px;margin-top:5px;"><span style="cursor:pointer;" (click)="cancelEdit()" *ngIf="isEditOpportunity || isAddOpportunity"><i class="fas fa-angle-double-left fa-2x"></i></span></span>-->
            <kendo-grid #opportunityGrid
                        [data]="gridData"
                        [pageSize]="gridState.take"
                        [skip]="gridState.skip"
                        [sort]="gridState.sort"
                        [filter]="gridState.filter"
                        [pageable]="true"
                        [sortable]="true"
                        [filterable]="true"
                        [resizable]="true"
                        [autoSize]="true"
                        (dataStateChange)="dataStateChange($event)">
                <ng-template kendoGridToolbarTemplate>
                    <button class="btn btn-sml btn-primary" title="Add New" tabindex="-1" (click)="addNew()" *ngIf="!isEditOpportunity && !isAddOpportunity"><i class="fas fa-plus"></i></button>
                </ng-template>
                <kendo-grid-column title="Action" width="100">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <button type="button" class="btn btn-sml btn-success m-1" title="Edit" tabindex="-1" (click)="edit(dataItem.opportunityID, true)"><i class="fas fa-pencil-alt"></i></button>
                        <!--<button type="button" class="btn btn-sml btn-secondary m-1" title="Edit" tabindex="-1" (click)="viewSalesCycle(dataItem)"><i class="fas fa-tasks"></i></button>-->
                        <!--<button kendoGridEditCommand type="button" [primary]="true" style="margin: 5px;">Edit</button>-->
                        <!--<button class="k-button k-primary k-grid-edit-command" (click)="viewSalesCycle(dataItem)" style="margin: 5px;">Checklist</button>-->
                        <!--<button kendoGridSaveCommand type="button" [primary]="true">Save</button>-->
                        <!--<button kendoGridCancelCommand type="button">Cancel</button>-->
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="productName" title="Product"></kendo-grid-column>
                <kendo-grid-column field="title" title="Title"></kendo-grid-column>
                <kendo-grid-column field="salesCycleDescription" title="Sales Cycle"></kendo-grid-column>
                <kendo-grid-column field="estimatedRevenue" title="Est Revenue" format="{0:c}"></kendo-grid-column>
                <kendo-grid-column field="createDate" title="Start Date">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        {{dataItem.createDate | date: 'M/dd/yyyy'}}
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="opportunity.dueDate" title="Due">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        {{dataItem.dueDate | date: 'M/dd/yyyy'}}
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="opportunity.expectedCloseDate" title="Close">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        {{dataItem.expectedCloseDate | date: 'M/dd/yyyy'}}
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="orderCount" title="Orders"></kendo-grid-column>
                <kendo-grid-column field="laneCount" title="Lanes"></kendo-grid-column>
                <kendo-grid-column field="bidAnnualGross" format="{0:c}" title="Bid Gross"></kendo-grid-column>
                <kendo-grid-column field="bidAnnualCost" format="{0:c}" title="Bid Cost"></kendo-grid-column>
                <kendo-grid-column field="bidAnnualNet" format="{0:c}" title="Bid Net"></kendo-grid-column>
                <kendo-grid-column field="bidAverageNetPerOrder" format="{0:c}" title="Bid Avg Net/Order"></kendo-grid-column>
                <kendo-grid-column field="bidAverageMarginPerOrder" format="{0:c}" title="Bid Avg Margin/Order"></kendo-grid-column>
                <kendo-grid-column field="expectedOrderCount" title="Expected Won Cnt"></kendo-grid-column>
                <kendo-grid-column field="expectedAnnualGross" format="{0:c}" title="Expected Won Gross"></kendo-grid-column>
                <kendo-grid-column field="expectedAnnualCost" format="{0:c}" title="Expected Won Cost"></kendo-grid-column>
                <kendo-grid-column field="expectedAnnualNet" format="{0:c}" title="Expected Won Net"></kendo-grid-column>
                <kendo-grid-column field="actualOrderCount" title="Actual Cnt"></kendo-grid-column>
                <kendo-grid-column field="actualAnnualGross" format="{0:c}" title="Actual Gross"></kendo-grid-column>
                <kendo-grid-column field="actualAnnualCost" format="{0:c}" title="Actual Cost"></kendo-grid-column>
                <kendo-grid-column field="actualAnnualNet" format="{0:c}" title="Actual Net"></kendo-grid-column>
            </kendo-grid>
        </div>

        <!-- Edit Customer Opportunity form -->
        <div class="wrapper col-sm-12" *ngIf="isEditOpportunity || isAddOpportunity">
            <div class="k-float-right">
                <button type="button" class="btn btn-secondary" (click)="refreshAfterSave()"><i class="fas fa-times"></i></button>
            </div>
            <kendo-expansionpanel [title]="'Opportunity'"
                                  [subtitle]="''"
                                  [expanded]="true">
                <customer-opportunity-form [opportunityID]="opportunityID" [customerID]="customerID" (onRefresh)="refreshAfterSave()"></customer-opportunity-form>
            </kendo-expansionpanel>
            <kendo-expansionpanel [title]="'Sales Cycle Checklist'"
                                  [subtitle]="''"
                                  [disabled]="isAddOpportunity"
                                  [expanded]="isEditOpportunity">
                <customer-opportunity-sales-cycle [opportunityID]="opportunityID" [opportunitySalesCycleMapID]="opportunitySalesCycleMapID"></customer-opportunity-sales-cycle>
            </kendo-expansionpanel>
            <kendo-expansionpanel [title]="'RFQ Kickoff'"
                                  [subtitle]="''"
                                  [disabled]="isAddOpportunity"
                                  [expanded]="false">
                <customer-opportunity-question [opportunityID]="opportunityID"></customer-opportunity-question>
            </kendo-expansionpanel>
            <kendo-expansionpanel [title]="'Actions'"
                                  [subtitle]="''"
                                  [disabled]="isAddOpportunity"
                                  [expanded]="isEditOpportunity">
                <customer-action-grid [opportunityID]="opportunityID" [customerID]="customerID" (onRefresh)="cancelEdit()"></customer-action-grid>
            </kendo-expansionpanel>
            <kendo-expansionpanel [title]="'Opportunity Lanes'"
                                  [subtitle]="''"
                                  [disabled]="isAddOpportunity"
                                  [expanded]="isEditOpportunity">
                <customer-opportunity-lane-grid [opportunityID]="opportunityID" [productID]="productID"></customer-opportunity-lane-grid>
            </kendo-expansionpanel>
        </div>
    </div>
</kendo-expansionpanel>
